import React from "react";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import Recorder from "./recorder";
import QuestionBox from "./questionbox";
import ResultBox from "./ResultBox";
import ScoreCard from "./ScoreCard";
import SpacingBox from "./Spacing";
import ImageBox from "./ImageBox";
import HeadingPage from "./Heading";
import AudioPlayer from "./AudioPlayer";
import WriteBox from "./WordBox";
import MCQMultiSelect from "./MultiOptionSelect";

export default function MultiSelectPage() {
    const question = "Which of the following are fruits?";
    const options = ['Apple', 'Banana', 'Carrot', 'Durian', 'Eggplant', 'Fig', 'Grape'];

  return (
    <div>
      <Headerdash />
      <Sidebar />
      <div className="relative left-72 ml-3 top-28  bg-gray-100 h-auto  w-[1150px] rounded-sm">
        <HeadingPage
          title="Title"
          timer="12.13"
          difficulty="Medium"
          attempted="Attempted"
        />


        <QuestionBox question="Muth"/>
        {/* <div className="font-bold p-2 pt-4 ml-[1000px] ">Time left:9.22 </div> */}
        <MCQMultiSelect question={question} options={options} />

        <ScoreCard />
        <SpacingBox />
      </div>
    </div>
  );
}
